import { useTranslation } from 'react-i18next';
import type { OrderItem } from '@/types';

interface OrderItemsListProps {
  items: OrderItem[];
}

export default function OrderItemsList({ items }: OrderItemsListProps) {
  const { t } = useTranslation();

  return (
    <ul className="divide-y divide-background-100">
      {items.map((item) => (
        <li
          key={item.id}
          className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 md:px-5"
        >
          <div className="flex min-w-0 items-center gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-500">
              <i className="ri-shirt-line text-lg" aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-foreground-950">{item.itemName}</p>
              <p className="mt-0.5 text-xs text-foreground-500">
                {t(`items.service.${item.serviceType}`)}
              </p>
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1 text-sm font-medium text-foreground-800">
            <i className="ri-hashtag text-sm text-foreground-400" aria-hidden="true" />
            {item.quantity}
          </span>
        </li>
      ))}
    </ul>
  );
}